export const coerceUrl = (str) => {
    if (URL.canParse(str)) {
        return new URL(str);
    }
    else {
        const withProto = `https://${str}`;
        if (URL.canParse(withProto)) {
            return new URL(withProto);
        }
    }
    return null;
};
export const coerceUrlOrThrow = (str) => {
    const r = coerceUrl(str);
    if (r) {
        return r;
    }
    throw new Error(`coerceUrlOrThrow: ${str}`);
};
export const canCoerceUrl = (str) => {
    return URL.canParse(str) || URL.canParse(`https://${str}`);
};
export const hrefOmitProtocol = (url) => {
    return url.href.replace(/^(\w*?:\/\/)/, '');
};
//////////// normal
export const UTM_KEYS = ['source', 'medium', 'campaign', 'content'];
export const utmParam = (k) => `utm_${k}`;
export const UTM_PARAMS = [
    utmParam('source'),
    utmParam('medium'),
    utmParam('campaign'),
    utmParam('content'),
];
export const getUtmParams = (searchParams) => {
    return {
        utm_campaign: searchParams.get('utm_campaign') ?? undefined,
        utm_medium: searchParams.get('utm_medium') ?? undefined,
        utm_source: searchParams.get('utm_source') ?? undefined,
        utm_content: searchParams.get('utm_content') ?? undefined,
    };
};
//////////// extended
export const UTM_KEYS_EXTENDED = [...UTM_KEYS, 'referrer', 'term'];
export const utmParamExtended = (k) => `utm_${k}`;
export const UTM_PARAMS_EXTENDED = [
    ...UTM_PARAMS,
    utmParamExtended('referrer'),
    utmParamExtended('term'),
];
export const getUtmParamsExtended = (searchParams) => {
    return {
        ...getUtmParams(searchParams),
        utm_referrer: searchParams.get('utm_referrer') ?? undefined,
        utm_term: searchParams.get('utm_term') ?? undefined,
    };
};
//# sourceMappingURL=url.js.map